import React from "react";
import { Link } from "react-router-dom";
import "../../CSS/ProjectCard.css";

export default function ProjectsCard(props) {
  const { title, description, coverImg, file } = props;

  const isInternal = file.startsWith("/") && !file.startsWith("/Files");

  const content = (
    <>
      {coverImg && <img src={coverImg} alt={title} className="image" />}
      <div className="info">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </>
  );

  if (isInternal) {
    return (
      <Link to={file} className="Card-2">
        {content}
      </Link>
    );
  }

  return (
    <a href={file} className="Card-2" target="_blank" rel="noreferrer">
      {content}
    </a>
  );
}
